import { createFileRoute } from '@tanstack/react-router';
import { OperationsProfilePage } from '@/features/operations/operations-profile-page';

export const Route = createFileRoute('/operations/profile')({
  component: () => <OperationsProfilePage />,
});
